import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useParams } from 'react-router-dom'
import Scroll from 'react-scroll';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faPencil, faTrashCan, faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons'
import Select from 'react-select';
import { getSessionTemplateDetailAPI } from "../../../../API/SessionTemplate";
import { getSelectedOptions } from "../../../../Helpers/selectHelper";
import useLocalStorage from "../../../../Hooks/useLocalStorage";


function SessionTemplateVideoSectionDelete() {
    ////
    ////
    ////

    const { id, vsIndex, eIndex } = useParams()

    ////
    //// Component states.
    ////

    const [errors, setErrors] = useState({});
    const [sessionTemplate, setSessionTemplate] = useLocalStorage(id, "");
    const [isFetching, setFetching] = useState(false);

    ////
    //// API.
    ////

    function onSessionTemplateDetailSuccess(response){
        console.log("onSessionTemplateDetailSuccess: Starting...");
        setSessionTemplate(response);
    }

    function onSessionTemplateDetailError(apiErr) {
        console.log("onSessionTemplateDetailError: Starting...");
        setErrors(apiErr);

        // The following code will cause the screen to scroll to the top of
        // the page. Please see ``react-scroll`` for more information:
        // https://github.com/fisshy/react-scroll
        var scroll = Scroll.animateScroll;
        scroll.scrollToTop();
    }

    function onSessionTemplateDetailDone() {
        console.log("onSessionTemplateDetailDone: Starting...");
        setFetching(false);
    }

    ////
    //// Event handling.
    ////

    // (Do nothing)

    ////
    //// Misc.
    ////

    useEffect(() => {
        let mounted = true;

        if (mounted) {
            window.scrollTo(0, 0);  // Start the page at the top of the page.
            setFetching(true);
            getSessionTemplateDetailAPI(
                id,
                onSessionTemplateDetailSuccess,
                onSessionTemplateDetailError,
                onSessionTemplateDetailDone
            );
        }

        return () => { mounted = false; }
    }, [id]);

    ////
    //// Component rendering.
    ////

    const videoSection = sessionTemplate.videoSections[vsIndex];
    const { exercises } = videoSection;
    console.log(exercises);
    const exercise = exercises[eIndex];

    // SPECIAL THANKS TO: https://stackoverflow.com/a/9851769
    // Safari 3.0+ "[object HTMLReusableConstructor]"
    let isSafari = /constructor/i.test(window.HTMLReusable) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));

    return (
        <>
            <div class="container">
                <section class="section">
                    <nav class="breadcrumb" aria-label="breadcrumbs">
                        <ul>
                            <li><Link to="/dashboard">Dashboard</Link></li>
                            <li class=""><Link to="/session-templates" aria-current="page">Session Templates</Link></li>
                            <li class=""><Link to={`/session-template/${id}/video-sections`} aria-current="page">Details (Video Sections)</Link></li>
                            <li class=""><Link to={`/session-template/${id}/video-section/${vsIndex}`} aria-current="page">Video Section Detail</Link></li>
                            <li class=""><Link to={`/session-template/${id}/video-section/${vsIndex}/exercise/${eIndex}`} aria-current="page">Exercise Detail</Link></li>
                            <li class="is-active"><Link aria-current="page">Delete</Link></li>
                        </ul>
                    </nav>
                    <nav class="box">
                        <p class="title is-4">Exercise</p>
                        <p class="subtitle is-6"><FontAwesomeIcon className="fas" icon={faEye} />&nbsp;Details</p>

                        {isFetching && <div class="columns is-centered" style={{paddingTop: "20px"}}>
                            <div class="column has-text-centered is-2">
                                <div class="loader-wrapper is-centered">
                                  <div class="loader is-loading is-centered" style={{height: "80px", width: "80px"}}></div>
                                </div>
                            </div>
                        </div>}

                        {!isFetching && <div class="container">
                            <div class="field">
                                <label class="label">Name</label>
                                <div class="control">
                                    <input class="input" type="text" placeholder="Text input" value={exercise.name} disabled={true} />
                                </div>
                            </div>

                            <div class="field">
                                <label class="label">Type</label>
                                <div class="control">
                                    <input class="input" type="text" placeholder="Text input" value={exercise.type} disabled={true} />
                                </div>
                            </div>

                            <div class="field">
                                <label class="label">Duration</label>
                                <div class="control">
                                    <input class="input" type="text" placeholder="Text input" value={exercise.duration} disabled={true} />
                                </div>
                            </div>

                            <div class="field">
                                <label class="label">Preview Url</label>
                                <div class="control">
                                    <input class="input" type="text" placeholder="Text input" value={exercise.previewUrl} disabled={true} />
                                </div>
                            </div>

                            <div class="field">
                                <label class="label">Preview Description</label>
                                <div class="control">
                                    <input class="input" type="text" placeholder="Text input" value={exercise.previewDescription} disabled={true} />
                                </div>
                            </div>

                            <div class="field pb-4">
                                <label class="label">VideoUrl</label>
                                <div class="control">
                                    <input class="input" type="text" placeholder="Text input" value={exercise.videoUrl} disabled={true} />
                                </div>
                                {exercise.videoUrl
                                    ? <>
                                        {!isSafari
                                        ? <>
                                            <article class="message is-warning pt-0">
                                              <div class="message-body">
                                                Your web browser may not support the <i>m3u8 file format</i> so you'll need to download an accompanying plugin to view the video content. Here is the recommended plugin for Chrome Web browser:
                                                <br/><br/>
                                                - <b><a href="https://chrome.google.com/webstore/detail/native-hls-playback/emnphkkblegpebimobpbekeedfgemhof">Native HLS Playback&nbsp;<FontAwesomeIcon className="fas" icon={faArrowUpRightFromSquare} /></a></b>
                                              </div>
                                            </article>
                                            <div className="has-background-black box has-text-white has-text-centered is-size-3" style={{borderRadius: "20px"}}>
                                                <br />
                                                View video by <b><a href={exercise.videoUrl} target="_blank" rel="noreferrer">clicking here&nbsp;<FontAwesomeIcon className="fas" icon={faArrowUpRightFromSquare} /></a></b> to open in new tab. <br />
                                                <br />
                                            </div>

                                        </>
                                        : <>
                                            <div className="p-3 has-background-black box" style={{borderRadius: "20px"}}>
                                                <video width="100%" height="100%" controls>
                                                     <source src={exercise.videoUrl} type="application/x-mpegURL" />
                                                </video>
                                            </div>
                                        </>
                                        }
                                    </>
                                    : <p>Not ready</p>
                                }
                            </div>

                            <div class="columns">
                                <div class="column is-half">
                                    <Link to={`/session-template/${id}/video-section/${vsIndex}/exercise/${eIndex}`} class="button is-hidden-touch">Back</Link>
                                    <Link to={`/session-template/${id}/video-section/${vsIndex}/exercise/${eIndex}`} class="button is-fullwidth is-hidden-desktop">Back</Link>
                                </div>
                                <div class="column is-half has-text-right">
                                    <Link to={`/session-template/${id}/video-section/${vsIndex}`} class="button is-primary is-hidden-touch">Save</Link>
                                    <Link to={`/session-template/${id}/video-section/${vsIndex}`} class="button is-primary is-fullwidth is-hidden-desktop">Save</Link>
                                </div>
                            </div>

                        </div>}
                    </nav>
                </section>
            </div>
        </>
    );
}


export default SessionTemplateVideoSectionDelete;
